<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .container {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: utils.in_rem(12px);

    > .name-and-description {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(4px);

      > .name {
        display: block;
        @include mixins.h4();
      }

      > .description {
        display: block;
        @include mixins.body3-tooltip-and-caption();
      }
    }
  }
</style>

<script>
  import Logo from "../Logo.svelte";

  export let logo;
  export let name;
  export let description;
</script>

<div class="container">
  <div>
    <!-- needs to be inside a div for the width to stay consistent -->
    {#key logo}
      <Logo {logo} size="medium" />
    {/key}
  </div>
  <div class="name-and-description">
    <div class="name">{name}</div>
    <div class="description">{description}</div>
  </div>
</div>
